import { ThumbnailFile } from '@/types/productV2'

export default async function getThumbnail2D(filename = 'thumbnail.png'): Promise<ThumbnailFile> {
  const srcCanvas = document.querySelector('#section-2d-plugin canvas') as HTMLCanvasElement
  if (!srcCanvas) throw new Error('2D canvas not found')

  // Center-crop to square (matching 3D behavior)
  const W = srcCanvas.width,
    H = srcCanvas.height,
    S = Math.min(W, H)
  const sx = (W - S) >> 1,
    sy = (H - S) >> 1

  const out = document.createElement('canvas')
  out.width = S
  out.height = S
  const ctx = out.getContext('2d')
  if (!ctx) throw new Error('2D context not available')
  ctx.drawImage(srcCanvas, sx, sy, S, S, 0, 0, S, S)

  const blob: Blob = await new Promise((res) => out.toBlob((b) => res(b as Blob), 'image/png'))
  const file = new File([blob], filename, { type: 'image/png' })

  const string = await new Promise<string>((res) => {
    const r = new FileReader()
    r.onload = () => res(r.result as string)
    r.readAsDataURL(blob)
  })

  return {
    data: file,
    string,
    name: filename,
    size: file.size,
    type: file.type,
    url: '',
    fileExtension: 'png',
  }
}
